import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { useTeam } from "~/contexts/TeamProvider";

import { apiClient } from "../api/ApiClient";
import { PaginationConfig } from "../components/ui/pagination/Pagination";

const MEMBERSHIP_AUTHORIZATIONS = "destroy,promote,demote";
const INVITATION_AUTHORIZATIONS = "destroy,resend";

export const useTeamMembers = (type: "active" | "pending") => {
  const { team } = useTeam();

  const [pagination, setPagination] = useState<PaginationConfig>({
    currentPage: 1,
    itemsPerPage: 10,
    nextPage: null,
    prevPage: null,
    totalPages: 1,
    totalItems: 10,
  });

  const { data, isLoading } = useQuery({
    queryKey: [`${type}TeamMembers`, team?.id, pagination.currentPage],
    queryFn: async () => {
      const response =
        type === "active"
          ? await apiClient.memberships.membershipsList(
              {
                "page[size]": pagination.itemsPerPage,
                "page[number]": pagination.currentPage,
              },
              {
                headers: {
                  "Authorize-Member-Actions": MEMBERSHIP_AUTHORIZATIONS,
                },
              },
            )
          : await apiClient.invitations.invitationsList(
              {
                "page[size]": pagination.itemsPerPage,
                "page[number]": pagination.currentPage,
              },
              {
                headers: {
                  "Authorize-Member-Actions": INVITATION_AUTHORIZATIONS,
                },
              },
            );

      const { headers } = response;
      //@ts-expect-error BE types are not correct
      const authorizations = response?.data?.authorizations || {};
      setPagination((prev) => ({
        ...prev,
        totalItems: Number(headers.get("x-pager-total-count")),
        nextPage: Number(headers.get("x-pager-next-page")),
        prevPage: Number(headers.get("x-pager-prev-page")),
        totalPages: Number(headers.get("x-pager-total-pages")),
      }));

      return {
        //@ts-expect-error BE types are not correct
        members: response?.data?.memberships || response?.data?.invitations,
        authorizations,
      };
    },
  });

  return {
    data: data?.members ?? [],
    isLoading,
    pagination,
    setPagination,
    authorizations: data?.authorizations,
  };
};
